import type {FC, ReactNode} from 'react';

interface FormGroupPrefixProps {
  readonly children: ReactNode;
}

const FormGroupPrefix: FC<FormGroupPrefixProps> = ({children}) => <span className="py-3 pr-2">{children}</span>;

export default FormGroupPrefix;
